var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":"Trigger options"}},[_c('date-picker',{staticClass:"w-100",attrs:{"input-class":"form-control","clearable":false,"value-type":"format","format":"HH:mm:ss","type":"time"},model:{value:(_vm.trigger.value),callback:function ($$v) {_vm.$set(_vm.trigger, "value", $$v)},expression:"trigger.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }